import React from "react";

import CommunicationAnswerPage from "pages/communication/CommunicationAnswerPage";
import { communicationAnswerConfigs } from "pages/communication/model/communicationAnswerConfigs";

function AskAnswer() {
  return <CommunicationAnswerPage config={communicationAnswerConfigs.ask} />;
}

export default AskAnswer;
